/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var NumbersInputIcon = createIcon("NumbersInputIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 16.245V9.499a.751.751 0 00-1.2-.6l-1.8 1.35m1.5 5.996h3m3.753-6.005a2.181 2.181 0 012.068-1.49v0a2.18 2.18 0 012.179 2.18v0c0 .525-.21 1.028-.58 1.4l-3.92 3.919h4.5m3.5-5.999a1.5 1.5 0 011.5-1.5h1.135a1.873 1.873 0 01-.008 3.745 1.873 1.873 0 11.008 3.746H19.25a1.5 1.5 0 01-1.5-1.5",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});